import { useNavigate } from 'react-router-dom';
import { useTranslation } from '../../../utils/useTranslation';
import { SmartDrawer } from '../../feedback/SmartDrawer';
import { Button } from '../../input/Button';
import { Box } from '../../layout/Box';
import { Flex } from '../../layout/Flex';
import { Typography } from '../../typography/Typography';

export const CpaModerationDialog = () => {
    const navigate = useNavigate();
    const t = useTranslation();

    const handleClose = () => {
        navigate(-1);
    };

    const titleContent = (
        <Typography variant="title2" weight="bold">
            {t('Регистрация')}
        </Typography>
    );

    const mainContent = (
        <Flex direction="column" spacing={4}>
            <Box>
                <Typography variant="body">
                    {t(
                        'Проверяем регистрацию. После проверки у вас отобразится баланс вознаграждения.',
                    )}
                </Typography>
            </Box>

            <Box width="100%">
                <Button
                    variant="filled"
                    size="l"
                    width="100%"
                    style={{ letterSpacing: '0.7px' }}
                    onClick={handleClose}
                >
                    {t('Хорошо')}
                </Button>
            </Box>
        </Flex>
    );

    return (
        <SmartDrawer
            onClose={handleClose}
            titleContent={titleContent}
            mainContent={mainContent}
            forceCloseButton={true}
            hideTrigger={true}
        />
    );
};
